import { axiosInstance } from "@/resources/requestInfo";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { schemeRoutes } from "./routes";
import { ISchemeResponse } from "./type";

export const fetchScheme = createAsyncThunk<ISchemeResponse[]>(
  "scheme/fetchScheme",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(schemeRoutes.GET_SCHEME);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);